// extracted by mini-css-extract-plugin
module.exports = {"resumeButton":"z4Tuh-trO0SwM5FJUQi2M"};